const translations = {
  'nav.about': 'Chi siamo',
  'nav.packages': 'Pacchetti',
  'nav.calculator': 'Calcolatore',
  'nav.contacts': 'Contatti',
  'nav.cta': 'Inizia a investire',

  'hero.badge': 'Tendenza Stagionale · Primavera 2025',
  'hero.title_p1': 'La crescita primaverile del',
  'hero.title_hl': 'mais',
  'hero.title_p2': '— opportunità di guadagnare su una tendenza stagionale',
  'hero.desc': 'Storicamente, i prezzi del mais aumentano in primavera a causa della maggiore domanda da parte dei produttori di mangimi, bioetanolo e preparazione della stagione agricola. Gli investitori usano questo ciclo stagionale ogni anno.',
  'hero.cta1': 'Calcola il profitto ora',
  'hero.cta2': 'Vedi i pacchetti',
  'hero.stat1.val': '+34%',
  'hero.stat1.label': 'Crescita media primaverile',
  'hero.stat2.val': '5+ anni',
  'hero.stat2.label': 'Trend stabile',
  'hero.stat3.val': 'TOP-3',
  'hero.stat3.label': 'Asset agricolo mondiale',
  'hero.scroll': 'scorri verso il basso',
  'hero.chart.title': 'Dinamica del Prezzo Corn · Primavera',
  'hero.chart.subtitle': 'Crescita indicizzata (Feb = 100%)',
  'hero.chart.maxgrowth': '+38%',
  'hero.chart.maxlabel': 'Crescita massima stagionale',
  'hero.chart.years': '100%',
  'hero.chart.yearslabel': 'Anni con crescita positiva',
  'hero.months.0': 'Feb',
  'hero.months.1': 'Mar',
  'hero.months.2': 'Apr',
  'hero.months.3': 'Mag',

  'price.badge': 'Analisi Stagionale',
  'price.title_p1': 'Perché il mais',
  'price.title_hl': 'cresce in primavera?',
  'price.subtitle': 'Cinque fattori chiave che formano un trend di prezzo stabile ogni anno',
  'price.r1.title': 'Domanda dall\'allevamento',
  'price.r1.desc': 'In primavera, la domanda di mangimi aumenta da parte delle aziende zootecniche che si preparano per la stagione attiva.',
  'price.r1.statLabel': 'crescita della domanda',
  'price.r2.title': 'Campagna di semina',
  'price.r2.desc': 'L\'inizio del periodo attivo di semina crea clamore sul mercato e pressione sulle scorte disponibili.',
  'price.r2.statLabel': 'crescita dell\'attività',
  'price.r3.title': 'Produttori di bioetanolo',
  'price.r3.desc': 'Gli impianti di bioetanolo aumentano gli acquisti di mais per la produzione di carburante nella stagione primaverile.',
  'price.r3.statLabel': 'crescita degli acquisti',
  'price.r4.title': 'Esaurimento delle scorte',
  'price.r4.desc': 'In primavera, le scorte dell\'anno precedente si riducono, creando una carenza di offerta che spinge i prezzi verso l\'alto.',
  'price.r4.statLabel': 'scorte rimanenti',
  'price.r5.title': 'Aspettative del mercato',
  'price.r5.desc': 'Il mercato incorpora le aspettative del raccolto futuro — l\'incertezza aumenta la volatilità e il potenziale di crescita.',
  'price.r5.statLabel': 'crescita della volatilità',
  'price.banner.avg': 'Crescita media in 5 anni',
  'price.banner.desc': 'Secondo le statistiche degli anni passati, la stagione primaverile è uno dei periodi di crescita più attivi per il prezzo di',
  'price.banner.corn': 'Corn',
  'price.banner.desc2': '.',
  'price.banner.disclaimer': 'Dati storici CME Group, USDA · non è una consulenza finanziaria',
  'price.banner.years': 'Anni con crescita (5/5)',

  'pkg.badge': 'Contratti di Investimento',
  'pkg.title_p1': 'Scegli il tuo',
  'pkg.title_hl': 'contratto',
  'pkg.title_p2': 'di investimento',
  'pkg.subtitle': 'Tre livelli di partecipazione — dall\'inizio al profitto massimo',
  'pkg.start.name': 'Contratto Start',
  'pkg.balance.name': 'Contratto Balance',
  'pkg.premium.name': 'Contratto Premium',
  'pkg.seasonal': 'Investimenti Corn · 2 giorni',
  'pkg.investment': 'Investimento',
  'pkg.duration': 'Durata:',
  'pkg.days': 'giorni',
  'pkg.yield': 'Rendimento',
  'pkg.profit': 'Profitto:',
  'pkg.cta': 'Inizia a investire',
  'pkg.popular': 'Popolare',
  'pkg.max': 'Massimo',
  'pkg.disclaimer': '* Tutti i dati sul rendimento si basano sulla dinamica storica del mercato. Gli investimenti comportano rischi.',
  'pkg.f.threshold': 'Soglia di ingresso — €{{amount}}',
  'pkg.f.profit': 'Profitto {{pct}}% in 2 giorni',
  'pkg.f.report.monthly': 'Report mensile',
  'pkg.f.report.weekly': 'Report settimanale',
  'pkg.f.report.daily': 'Report giornaliero',
  'pkg.f.support.reg': 'Supporto 5/7',
  'pkg.f.support.prio': 'Supporto prioritario',
  'pkg.f.support.vip': 'Supporto VIP 7/7',
  'pkg.f.account': 'Account personale',
  'pkg.f.analytics': 'Analisi di mercato',
  'pkg.f.manager': 'Manager personale',
  'pkg.duration_fixed': 'Durata fissa per tutti i contratti',

  'calc.badge': 'Calcolatore di Rendimento',
  'calc.title_p1': 'Calcola',
  'calc.title_hl': 'il tuo profitto',
  'calc.subtitle': 'Inserisci i parametri e scopri il reddito atteso',
  'calc.params': 'Parametri di Investimento',
  'calc.amount': 'Importo Investimento',
  'calc.package': 'Pacchetto Investimento',
  'calc.dur.label': 'Durata Investimento',
  'calc.dur.val': '2 giorni',
  'calc.dur.fixed': 'Durata fissa per tutti i contratti',
  'calc.result': 'Risultato del Calcolo',
  'calc.expected': 'Profitto Atteso',
  'calc.per2days': '% per 2 giorni',
  'calc.total': 'Importo Totale',
  'calc.invested': 'Investimento',
  'calc.pkg.label': 'Pacchetto',
  'calc.period': 'Periodo',
  'calc.period.val': '2 giorni',
  'calc.bar.invested': 'Investito',
  'calc.bar.profit': 'Profitto',
  'calc.cta': 'Scegli un Contratto',

  'activity.header': 'Attività della Piattaforma',
  'activity.invested': 'ha investito',
  'activity.profit': 'ha guadagnato',
  'activity.just_now': 'proprio adesso',
  'activity.1min': '1 min fa',
  'activity.2min': '2 min fa',
  'activity.3min': '3 min fa',
  'activity.disclaimer': 'dimostrazione in tempo reale dell\'attività degli utenti della piattaforma',
  'activity.badge': 'Comunità degli Investitori',
  'activity.title_p1': 'Migliaia di investitori già',
  'activity.title_hl': 'guadagnano con noi',
  'activity.desc': 'Ogni giorno i nostri clienti guadagnano profitti dalla tendenza stagionale del mais. Unisciti a migliaia di investitori che usano questo ciclo ogni anno.',
  'activity.stat1': 'Investitori Attivi',
  'activity.stat2': 'Asset in Gestione',
  'activity.stat3': 'Clienti Soddisfatti',
  'activity.join': 'Unisciti',
  'activity.view': 'Vedi i pacchetti',

  'toast.earned': 'ha appena guadagnato',

  'trust.badge': 'Perché ci fidano',
  'trust.title_p1': 'Affidabilità provata dal',
  'trust.title_hl': 'tempo',
  'trust.subtitle': 'Corn è uno degli asset agricoli più liquidi e prevedibili al mondo',
  'trust.item1.title': 'Strumento di trading più antico',
  'trust.item1.desc': 'Gli investimenti nei mercati delle materie prime agricole sono uno degli strumenti di trading stagionale più antichi — provato da secoli di storia del mercato.',
  'trust.item2.title': 'TOP-3 Asset Agricoli Mondiali',
  'trust.item2.desc': 'Corn è nella top-3 degli asset agricoli globali per volume di trading e liquidità sulle borse CME e CBOT.',
  'trust.item3.title': 'Maggiore volatilità primaverile',
  'trust.item3.desc': 'La stagione primaverile storicamente mostra una maggiore volatilità e potenziale di crescita, creando opportunità uniche per gli investitori.',
  'trust.stat1.label': 'anni di storia del mercato',
  'trust.stat2.label': 'volume di trading annuale',
  'trust.stat3.label': 'tra gli asset agricoli',
  'trust.stat4.label': 'liquidità delle posizioni',
  'trust.cta.desc': 'Pronto ad approfittare del trend primaverile? Calcola il tuo potenziale profitto ora.',
  'trust.cta.btn': 'Calcola il profitto ora',

  'footer.tagline': '— Investimenti Stagionali in Corn',
  'footer.about': 'Chi siamo',
  'footer.packages': 'Pacchetti',
  'footer.calculator': 'Calcolatore',
  'footer.disclaimer': '© 2025 CornVest. Non è una consulenza di investimento.',
};

export default translations;
